<template>
  <div v-show="isActive">
    <div v-if="hasErrors" class="alert alert-danger"><strong>Fehler gefunden</strong></div>
    <slot></slot>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TabContent",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hasErrors: false,
    };
  },
  computed: {
    ...mapGetters({ tabs: "getGlobalTabs" }),
    isActive() {
      return this.tabs[this.$parent.id] === this.id;
    },
  },
  watch: {
    isActive(newVal) {
      if (newVal == true) {
        this.$nextTick(() => {
          Array.from(this.$children).forEach(child => {
            if (child.forceUpdate instanceof Function) {
              child.forceUpdate();
            }
          });
        });
      }
    },
  },
  mounted() {
    let errorCount = this.$el.querySelectorAll(".formError").length;
    this.hasErrors = errorCount > 0;
    if (this.hasErrors) {
      this.addTabToErrors(this.id);
      this.setActive();
    }
  },
  methods: {
    ...mapActions({ setGlobalTabs: "setGlobalTabs", addTabToErrors: "addTabToErrors" }),
    setActive() {
      this.setGlobalTabs({ [this.$parent.id]: this.id });
    },
  },
};
</script>
